export const MY_LOBBY_GROUP_ID = 0;

/** Custom sortings for tables belonging to specific group table */
export const GROUP_TABLES_CUSTOM_SORTING = {
  /** Custom sorting to be applied to blackjack and american blackjack tables when BO's sort_bj_category is configured */
  BJ_BY_SEATS: 'sortBjCategory',
} as const;

/**
 * Properties of a custom sorting rule
 *
 * note: the assumption is all BO configs for custom sorts have the same json structure, like:
 * ```
 * {
 *    enableSort: true,
 *    groupName: "a group name",
 * }
 * ```
 */
export const CUSTOM_SORT_CONFIG = {
  ENABLE_SORT_PROP: 'enableSort',
  GROUP_NAME_PROP: 'groupName',
};

/** All available options for BO config `tables_sorting_type` */
export const TABLES_SORTING_TYPE_CONFIG = {
  DEFAULT: 'default',
  LANGUAGE: 'language',
  LIMITS: 'limits',
};
